import API_BASE_URL from './apiConfig';

const searchProducts = async (data, page = 1) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, page }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const products = await response.json();
    return products;
  } catch (error) {
    console.error("Failed to fetch products:", error);
    throw error;
  }
};

export const getFilters = async () => {
  const response = await fetch(`${API_BASE_URL}/filters`);
  if (!response.ok) throw new Error("Failed to fetch filters");
  return response.json();
};

export const getTrendingDeals = async (limit = 20) => {
  const response = await fetch(`${API_BASE_URL}/v2/search/trending?limit=${limit}`);
  if (!response.ok) throw new Error("Failed to fetch trending deals");
  return response.json();
};

export default searchProducts;
